import { ApiModel, ApiRelationship, ApiResource } from 'lib/interfaces/api';
import { FeatureFlagsMap } from 'lib/interfaces/feature-flags';

export enum UserSessionStatus {
  Pending = 'pending',
  Active = 'active',
  Expired = 'expired',
}
export interface UserSessionAttributes {
  status: UserSessionStatus;
  'created-at': string;
  'expired-at': string | null;
  'ip-address': string;
  'user-agent': string;
}

export interface UserSessionRelationships {
  user: ApiRelationship<ApiModel.User>;
}

export type UserSession = ApiResource<
  UserSessionAttributes,
  UserSessionRelationships,
  ApiModel.UserSession
>;

export interface CurrentUserSessionMeta {
  'access-token': string;
  'refresh-token': string;
  'expires-at': string;
  'feature-flags': FeatureFlagsMap;
  'impersonation-session': string | undefined;
  'readme-jwt-token': string;
}
